import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import moreTasksQuery from './queries/more-tasks';
import { ErrorsInterface } from '../errors/errors-interface';
import { FilteredListServiceBase } from '../../../classes/filtered-list-service-base';
import taskListQuery from './queries/task-list';
import { TaskListResultInterface } from './definitions/task-list-result-interface';

interface TaskListResponse {
  task: {
    list: {
      output: TaskListResultInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskListService extends FilteredListServiceBase<TaskListResponse> {
  static cursor: String = null;
  resultApollo;

  constructor(public apollo: Apollo) {
    super(apollo);
  }

  fetchMore(): string {
    this.resultApollo.fetchMore({
      query: moreTasksQuery,
      variables: {
        cursor: TaskListService.cursor,
        sortingDesc: true,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newTasks = fetchMoreResult.task.moreTasks.output;
        const newList = [...previousResult.task.list.output, ...newTasks];
        TaskListService.cursor = fetchMoreResult.task.moreTasks.cursor;
      
        return {
          ...previousResult,
          task: {
            ...previousResult.task,
            list: {
              ...previousResult.task.list,
              output: newList
            }
          }
        };
      }      
    });

    return 'more';
  }

  getListQuery() {
    return taskListQuery;
  }

  getMutationQuery() {
    return null;
  }

  applyNewData(newResult) {
    return {
      task: {
        list: newResult,
      },
    };
  }
}
